import React from "react";
import { Paper, Typography, IconButton } from "@mui/material";
import Image from "next/image";
import { SxProps, Theme } from "@mui/system";
import FavoriteIcon from "@mui/icons-material/Favorite";

export interface SidebarImageProps {
  imgSrc?: string;
  name?: string;
  sx?: SxProps<Theme>;
  isLgDown?: boolean;
}

const SidebarImage: React.FC<SidebarImageProps> = ({
  imgSrc,
  name,
  sx,
  isLgDown,
}) => {
  return (
    <Paper
      sx={{
        paddingY: "35px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        position: "relative",
        height: { xs: "250px", md: "100%" },
        minHeight: { xs: "250px", md: "300px" },
        ...sx,
      }}
    >
      <Image
        src={imgSrc || "https://via.placeholder.com/60"}
        alt={name}
        width={200}
        height={200}
      />
      <IconButton sx={{ position: "absolute", top: 3, right: 3 }}>
        <FavoriteIcon
          fontSize="medium"
          sx={{
            color: "#90909025",
          }}
        />
      </IconButton>
      {isLgDown && (
        <Typography
          component="h6"
          sx={{
            position: "absolute",
            bottom: 5,
            fontSize: { xs: "10px", md: "14px" },
          }}
        >
          Внешний вид товара может отличаться от изображенного на фото
        </Typography>
      )}
    </Paper>
  );
};

export default SidebarImage;
